module.exports = __webpack_public_path__ + "img/snb_companydemo.2b77c75f.svg";